import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d17376a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "binding-reminder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "绑定后可扫码登录，不用记密码", -1))
const _hoisted_3 = { class: "reminder-buttons" }
const _hoisted_4 = {
  key: 0,
  class: "binding-demo-controls"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "微信绑定提醒 · 模拟状态", -1))

import {automaticAvailable,automaticPresented,automaticClosed} from '@/utils/automaticNotices'
import {computed,ref,watch,onMounted,onBeforeUnmount} from 'vue'
import {useRoute} from 'vue-router'
import store from '@/store'
import request from '@/utils/request'
import {clearLegacyPasswordAfterWechatBinding,readRememberedAccount} from '@/utils/rememberedAccount'
import {bindingReminderKey,readBindingReminder,postponeBindingReminder,clearBindingReminder} from '@/utils/wechatBindingReminder'
import WechatBindingFlow from '@/components/InlineWechatBinding.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WechatBindingReminder',
  props: {
    channel: null
  },
  setup(__props: any) {

const props = __props as {channel:'web'|'admin'};

const route=useRoute()
const flowVisible=ref(false),status=ref<boolean|null>(null),canPresent=ref(false)
const preview=computed(()=>route.query.bindingReminderPreview==='1'),simulatedBound=ref(route.query.bindingBoundPreview==='1'),dismissed=ref(false)
const account=computed(()=>store.getters.token&&store.getters.userInfo?.id&&(props.channel==='admin'||Number(store.getters.orgId)===Number(store.getters.userInfo.orgId))?JSON.stringify([props.channel,store.getters.userInfo.id,store.getters.userInfo.orgId]):'')
const reminderKey=computed(()=>account.value?bindingReminderKey(props.channel,Number(store.getters.userInfo.id),Number(store.getters.userInfo.orgId)):'')
let memoryUntil=0
const requestIdentity=()=>JSON.stringify([account.value,store.getters.token])
const bound=computed(()=>preview.value?simulatedBound.value:status.value)
const safe=computed(()=>props.channel==='web'?['/','/main','/main/index'].includes(route.path):['/','/platform','/platform/platforminfo'].includes(route.path))
const visible=computed(()=>!!account.value&&bound.value===false&&!dismissed.value&&safe.value&&canPresent.value)
let generation=0,lastRead=0,checking=false,disposed=false,timer:ReturnType<typeof setInterval>|undefined
function updatePresentation(){canPresent.value=(visible.value||automaticAvailable('binding'))&&document.visibilityState!=='hidden'&&!/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName||'')&&!Array.from(document.querySelectorAll('.ant-modal-wrap:not(.wechat-bind-reminder-shell),.ant-drawer-open')).some(el=>el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden')}
async function refresh(force=false){
 updatePresentation()
 if(dismissed.value&&!preview.value&&Date.now()>=Math.max(memoryUntil,readBindingReminder(localStorage,reminderKey.value).until))dismissed.value=false
 if(disposed||preview.value||!account.value||checking||document.visibilityState==='hidden'||(!force&&Date.now()-lastRead<30000))return
 const who=requestIdentity(),run=generation;checking=true;lastRead=Date.now()
 try{
  const {data}=await request({url:(props.channel==='web'?'customer':'system')+'/wechatLoginBindingStatus',method:'GET',quietNotification:true} as any)
  if(disposed||who!==requestIdentity()||run!==generation)return
  const actor={id:Number(store.getters.userInfo.id),orgId:Number(store.getters.userInfo.orgId),role:props.channel==='web'?'cus':'org'}
  if(!data||typeof data.bound!=='boolean'||Number(data.accountId)!==actor.id||Number(data.orgId)!==actor.orgId||data.role!==actor.role){status.value=null;return}
  status.value=data.bound
  if(data.bound===true){
   dismissed.value=false;memoryUntil=0;clearBindingReminder(localStorage,reminderKey.value)
   const key=props.channel==='web'?'userdata':'admin-remembered-account'
   if(clearLegacyPasswordAfterWechatBinding(window.localStorage,key,data,actor)){
    const remembered=readRememberedAccount(window.localStorage,key)
    if(props.channel==='web')store.state.user.userData=remembered
    window.dispatchEvent(new CustomEvent('legacy-account-migrated',{detail:{...actor,username:remembered.username}}))
   }
  }
 }catch{if(run===generation&&who===requestIdentity())status.value=null}
 finally{if(run===generation){checking=false;updatePresentation()}}
}
watch(requestIdentity,()=>{generation++;checking=false;lastRead=0;status.value=null;memoryUntil=0;dismissed.value=!preview.value&&readBindingReminder(localStorage,reminderKey.value).until>Date.now();void refresh(true)},{immediate:true})
watch(bound,(value,old)=>{if(value===false&&old===true){dismissed.value=false;memoryUntil=0;clearBindingReminder(localStorage,reminderKey.value)}})
// 首次展示也记录所属端的提醒间隔，避免关闭标签或刷新反复打扰；当前弹窗仍保留到用户操作。
let automaticShownAs=''
watch(visible,(value,old)=>{if(value&&!old&&!preview.value){automaticShownAs=account.value;automaticPresented('binding')}if(!value&&old){if(!preview.value&&automaticShownAs===account.value)automaticClosed();automaticShownAs=''}if(value&&!preview.value)memoryUntil=postponeBindingReminder(localStorage,reminderKey.value,Date.now(),false).until;else if(old&&memoryUntil>Date.now())dismissed.value=true})
watch(()=>route.path,()=>{updatePresentation();void refresh()})
function later(skip=true){dismissed.value=true;if(!preview.value)memoryUntil=postponeBindingReminder(localStorage,reminderKey.value,Date.now(),skip).until}
function bind(){later(false);flowVisible.value=true}
const changed=(event:StorageEvent)=>{if(event.key===reminderKey.value){memoryUntil=0;dismissed.value=readBindingReminder(localStorage,reminderKey.value).until>Date.now()}}
const foreground=()=>{void refresh(true)}
onMounted(()=>{updatePresentation();timer=setInterval(()=>{void refresh()},4000);document.addEventListener('visibilitychange',foreground);window.addEventListener('focus',foreground);window.addEventListener('storage',changed);window.addEventListener('wechat-login-binding-changed',foreground)})
onBeforeUnmount(()=>{disposed=true;generation++;clearInterval(timer);document.removeEventListener('visibilitychange',foreground);window.removeEventListener('focus',foreground);window.removeEventListener('storage',changed);window.removeEventListener('wechat-login-binding-changed',foreground)})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      visible: _unref(visible) && !flowVisible.value,
      title: "绑定微信",
      "wrap-class-name": "wechat-bind-reminder-shell",
      footer: null,
      "mask-closable": false,
      closable: false,
      width: 420
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (later()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("稍后")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: bind
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即绑定微信")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(WechatBindingFlow, {
      preview: _unref(preview),
      visible: flowVisible.value,
      "org-name": _unref(preview)?'当前账号（模拟）':(_unref(store).getters.userInfo?.orgName || '当前店铺'),
      "current-scope": __props.channel==='admin'?'管理端':'客户端',
      onClose: _cache[1] || (_cache[1] = ($event: any) => (flowVisible.value=false)),
      onBound: _cache[2] || (_cache[2] = ($event: any) => (simulatedBound.value=true)),
      onUnbound: _cache[3] || (_cache[3] = ($event: any) => {simulatedBound.value=false;dismissed.value=false;flowVisible.value=false})
    }, null, 8, ["preview", "visible", "org-name", "current-scope"]),
    (_unref(preview))
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(simulatedBound.value?'已绑定：不再提醒':'未绑定：需要提醒'), 1),
          _createVNode(_component_a_button, {
            size: "small",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (simulatedBound.value=true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("模拟绑定成功")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            size: "small",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {simulatedBound.value=false;dismissed.value=false})
          }, {
            default: _withCtx(() => [
              _createTextVNode("模拟解绑")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            size: "small",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (dismissed.value=false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("模拟下次登录")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})